import React from 'react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/common/Button';

const TechnicalIssuePage = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center border border-gray-100">
                <div className="flex justify-center mb-6">
                    <div className="bg-red-50 p-4 rounded-full">
                        <AlertTriangle size={48} className="text-red-500" />
                    </div>
                </div>

                <h1 className="text-2xl font-bold text-gray-900 mb-2">Technical Issue</h1>
                <p className="text-gray-600 mb-8 leading-relaxed">
                    We're sorry, but we're experiencing a technical difficulty. This could be due to a server update or a network interruption.
                </p>

                <div className="space-y-4">
                    <Button
                        onClick={() => window.location.reload()}
                        className="w-full h-12 flex items-center justify-center gap-2"
                        variant="primary"
                    >
                        <RefreshCw size={18} /> Try Again
                    </Button>

                    <Button
                        onClick={() => navigate('/login')}
                        className="w-full h-12 flex items-center justify-center gap-2"
                        variant="outline"
                    >
                        <Home size={18} /> Back to Login
                    </Button>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-50 text-xs text-gray-400">
                    If the problem persists, please contact support and provide error code: <span className="font-mono">AUTH_REF_01</span>
                </div>
            </div>
        </div>
    );
};

export default TechnicalIssuePage;
